var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-modal',{attrs:{"modal-id":_vm.modalId,"modal-size":"default","modalAlignment":"center"},on:{"close-modal":_vm.closeAddEditModal}},[_c('template',{slot:"body"},[_c('div',{staticClass:"px-primary"},[_vm._t("init"),_vm._v(" "),_vm._t("process"),_vm._v(" "),_vm._t("retry")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }